export default "__VITE_ASSET__DbXI6yHJ__"